import { type UseQueryResult, useQuery } from 'react-query';
import { type TableParamsType } from '../../types/common';
import {
  CompanySsoConfigurationService,
  PagedResultDto_CompanySsoConfigurationDto,
} from '@wealthlane/api-services/wealthlane-identity-service';

const useGetCompanySsoConfigList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_CompanySsoConfigurationDto | undefined,
  unknown
> => {
  const { filter, sorting, skipCount, maxResultCount } = tableInfo;

  const companySsoConfigList = useQuery(
    ['getCompanySsoConfigList', filter, sorting, skipCount, maxResultCount],
    async () => {
      return await handleRequest(
        CompanySsoConfigurationService.getApiIdentityApiAppCompanySsoConfiguration(
          filter,
          undefined,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
  );

  return companySsoConfigList;
};

export default useGetCompanySsoConfigList;
